/**
 * @file
 */

export default {
    issueList(state) {
        return state.topicData.issueList;
    },
    relatedLinkList(state) {
        return state.relatedLinkList;
    },
    topicList(state) {
        return state.topicData.qaList;
    },
    topicType(state) {
        return state.topicData.topicInfo.topicType;
    },
    isIssueType(state) {
        return state.isIssueType;
    },
    showRelateBoard(state, getters) {
        return (!getters.isIssueType && getters.relatedLinkList.length > 0)
            || getters.topicList.length > 0
            || getters.issueList.length > 0;
    },
    headerHeightChange(state) {
        return state.issueHeaderHeight > 120;
    }
};
